export default {
  getPageInfo: (state) => state.pageInfo,
  getList: (state) => state.list,
  getDetail: (state) => state.detail
};
